import {api} from "./service.js";	
const goods={
	getgoodinfo(info){//产品详细页
		return api.post("pc/product/info",info)
	},
	getgoodsclass(classid){
		return api.post("pc/class/list",{pid:classid})
	},
	getgoodsattr(classid){
		return api.post("pc/attribute/option",{id:classid})
	},
	getgoodslistbyclass(info){//搜索商品
		
		return api.post("pc/product/search",info)
	},
	//获取分类
	getClassAll(classid){
		return api.post("pc/class/all",{id:classid})
	},
	//收藏
	getStoreAdd(goodsid,status){
		if(status==undefined){
			status=0;
		}
		return api.post("pc/store/add",{product_id:goodsid,status:status})
	},
	//搜索页面
	getSearch(keyword,uid,page){
		return api.post("pc/keyword/search",{keyword:keyword,uid:uid,page})
	},
	//我的收藏列表
	getCollectionList(){
		return api.post("pc/user/store")
	},
	//获取商品下载关联信息
	getDownList(where){
		return api.post("pc/product/match",where)
	},
	//商品对比
	getCompare(ids){
		return api.post("pc/goods/compare",{ids:ids})
	}

}
export default goods;


// WEBPACK FOOTER //
// ./src/service/goods.js